module.exports = __webpack_public_path__ + "img/hr-curved-rail-vertical-right-bottom-ties-remnants.1dfefcd7.png";